import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Notify from "../../../Notify";
import { getData } from "../../../../services/library";
import { UrlApi } from "../../../../services/apirest";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function AnularFactura(props) {
  const [disBtn, setDisBtn] = useState(true);
  const [facturaObtenida, setFacturaObtenida] = useState();
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const handleClose = () => {
    props.onClose(false);
  };

  const obtenerFactura = () => {
    try {
      getData(
        "/envasado_pedidos/facturaNC/" + props.factura.id,
        setFacturaObtenida,
      );
    } catch (error) {
      console.log("error");
    } finally {
      setDisBtn(false);
    }
  };
  useEffect(() => {
    obtenerFactura();
  }, []);

  const anularFactura = async () => {
    setDisBtn(true);
    try {
      const facturaData = Array.isArray(facturaObtenida)
        ? facturaObtenida[0]
        : facturaObtenida;


      const response = await fetch(UrlApi + `/comprobantes/emitir_nc?envasado=1&origen=${4}&usuario=${localStorage.getItem("user")}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: facturaData.id_factura }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Error desconocido");
      }

      const result = await response.text();

      registrarAccion(
        DONDE.FACTURACION,
        `Anuló factura ${facturaData.nombre_comprobante} ${facturaData.nro_comprobante} (id_factura ${facturaData.id_factura}) del pedido ${props.factura.id} - se emitió NC`
      );

      await fetch(`${UrlApi}/envasado_pedidos/${props.factura.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ estado: 328 }),
      });
    } catch (error) {
      console.error("Error en la solicitud:", error.message);
      alert("Error al anular la factura: " + error.message);
    } finally {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.setOpen(false);
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Anulación de Factura: Pedido N°{props.factura.id}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere anular la factura?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                disabled={disBtn}
                onClick={anularFactura}
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default AnularFactura;
